import React from "react";
import PropTypes from "prop-types";
import footerStyle from "../assets/jss/components/footerStyle";
import { withStyles } from "@material-ui/core";
function Footer() {

  return (
    <div
      style={{
        height: "42px",
        backgroundColor: "#002767",
        color: "#ffffff",
        textAlign: "center",
        lineHeight: "42px",
        bottom: "0"
      }}
    >
    Copyright © {new Date().getFullYear()} Yoma Strategic Holdings Ltd
    </div>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(["primary"])
};

export default withStyles(footerStyle)(Footer);
